<template>
  <div class="replicatedDirectory">
    <MapModal
      :modalNode="modalNode"
      :title="lineInfoDirectoryCategory.title"
      :id="lineInfoDirectoryCategory.id"
      :close="close"
    >
      <template slot="content">
        <el-table :data="tableData" height="500px" style="width: 100%;">
          <el-table-column
            prop="startBrokenStake"
            align="center"
            label="起点桩号"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="endBrokenStake"
            align="center"
            label="终点桩号"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="elementType" align="center" label="类型">
          </el-table-column>
          <el-table-column prop="length" align="center" label="长度">
          </el-table-column>
          <el-table-column prop="radius" align="center" label="半径">
          </el-table-column>
          <el-table-column prop="a" align="center" label="A值">
          </el-table-column>
        </el-table>
      </template>
    </MapModal>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
export default {
  name: "lineInfoDirectory",
  components: { MapModal },
  props: ["close", "tableData"],
  data() {
    return {
      lineInfoDirectoryCategory: {
        title: "线元详情",
        id: "lineInfo", // id和ref使用的同一个
      },
      modalNode: {
        lineInfoDirectoryCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 7,
            left: 31,
            unit: "%", // 默认px
          },
          width: "35%", // 宽度配置 默认450px
          height: "550px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/box.scss";
.replicatedDirectory {
  @include box_wh(320, 560, true, 386);
  padding: 0;
  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  .el-button.el-button--primary {
    margin: 0px 5px !important;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
</style>
